import { customElement, containerless } from "aurelia-framework";
import { bindable } from "aurelia-typed-observable-plugin";
import { SynchronizationPropertiesTable } from "./synchronization-properties-table";

@containerless
@customElement("synchronization-to-maestro-properties-table")
export class SynchronizationToMaestroPropertiesTable extends SynchronizationPropertiesTable {

}
